module.exports = __webpack_public_path__ + "img/chevron_right_gray600.9b3fa804.svg";